<script lang="ts" setup>
  interface IconProps {
    svgPathClass?: string
    size?: number
  }

  withDefaults(defineProps<IconProps>(), {
    svgPathClass: 'stroke-black dark:stroke-white',
    size: 16,
  })
</script>

<template>
  <svg
    data-testid="close-icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.25 2.75L2.75 13.25"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :class="svgPathClass"
    />
    <path
      d="M2.75 2.75L13.25 13.25"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :class="svgPathClass"
    />
  </svg>
</template>
